export default function ErrorPage() {
    return (
        <div className="flex flex-col gap-10 justify-center m-auto">
            <h1 className="text-white text-center text-5xl font-bold tracking-wide">No Page Found</h1>
        </div>
    )
}